import { render, staticRenderFns } from "./add-link-item.vue?vue&type=template&id=59c716cc&scoped=true&"
import script from "./add-link-item.vue?vue&type=script&lang=js&"
export * from "./add-link-item.vue?vue&type=script&lang=js&"
import style0 from "./add-link-item.vue?vue&type=style&index=0&id=59c716cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c716cc",
  null
  
)

export default component.exports